import "./App.css";
import Home from "./component/Home";
import { ThemeProvider } from "@material-ui/core/styles";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import { heIL } from "@material-ui/core/locale";

const font = "'Assistant','Open Sans',sans-serif";

const theme = createMuiTheme(
  {
    direction: "rtl",
    typography: {
      fontFamily: font,
    },
    palette: {
      primary: { main: "#1976d2" },
    },
    overrides: {
      MuiInputLabel: {
        formControl: {
          right: 0,
          left: "inherit",
        },
      },
      MuiDialogTitle: {
        root: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        },
      },
    },
  },
  heIL
);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Home />
      </div>
    </ThemeProvider>
  );
}

export default App;
